export default __webpack_public_path__ + "static/media/Bidder.ac69bafc.csv";